import campus from './campus.vue';
import role from './role.vue';
import studentStatus from './student-status.vue';
import grade from './grade.vue';
import course from './course.vue';
import clazz from './class.vue';
import teacher from './teacher.vue';
import priceItem from './price-item.vue';
import studentAge from './student-age.vue';
import Student from './student.vue';
import bindStatus from './bind-status.vue';
import ldStatus from './ld-status.vue';
import birthMonth from './birth-month.vue';
import classStatus from './class-status.vue';
import courseCasCader from './course-cascader.vue';
import classroom from './classroom.vue';
import commodity from './commodity.vue';
import courseSignType from './courseSign-type.vue';
import chargeType from './charge-type.vue';
import orderFlag from './order-flag.vue';
import universalCard from './universalCard.vue';
import orderSource from './order-source.vue';
import orderStatus from './order-status.vue';
import productTypes from './product-types.vue';
import courseTypes from './course-type.vue';
import attendanceTypes from './attendance-type.vue';
import teacherStatus from './teacher-status.vue';
import teacherRoles from './teacher-roles.vue';
import courseConsumeType from './courseConsume-type.vue';
import comeFroms from './come-froms.vue';
import customAccount from './custom-account.vue';
import cepingTemplate from './ceping-template.vue';
import teacherMulti from './teacher-multi.vue';
import storeCardStatus from './storecard-status.vue';
import recordTypes from './record-types.vue';
import studentMultiple from './student-multiple.vue';
import courseBase from './course-base.vue';
import stuCardName from './stu-cardname.vue';
import archivesTypes from './archives-types.vue';
import studentStatusNew from './student-status-new.vue';
import studentSex from './student-sex.vue';
import classMulti from './class-multiple.vue';
import studentInClass from './student-in-class.vue';
import teacherSpecial from './teacher-special.vue';
import memberScroeType from './member-score-type.vue';
import studentIntroducer from './student-introducer.vue';
import studentBase from './student-base.vue';

export default [
  customAccount,
  campus,
  role,
  studentStatus,
  grade,
  course,
  clazz,
  teacher,
  priceItem,
  studentAge,
  bindStatus,
  ldStatus,
  birthMonth,
  classStatus,
  courseCasCader,
  classroom,
  Student,
  commodity,
  courseSignType,
  chargeType,
  orderFlag,
  universalCard,
  orderSource,
  orderStatus,
  productTypes,
  courseTypes,
  attendanceTypes,
  teacherStatus,
  teacherRoles,
  courseConsumeType,
  comeFroms,
  cepingTemplate,
  teacherMulti,
  storeCardStatus,
  recordTypes,
  studentMultiple,
  courseBase,
  stuCardName,
  archivesTypes,
  studentStatusNew,
  studentSex,
  classMulti,
  studentInClass,
  teacherSpecial,
  memberScroeType,
  studentIntroducer,
  studentBase,
];
